<template>
  <div class="main">
    <div class="top-box">
      <div class="top-title">常用功能</div>
      <div class="top-list">
        <div
            class="top-item"
            v-for="(item, index) in menuList"
            @click="menuItemClick(item.path)"
            :key="index"
        >
          <div>
            <img :src="item.img" alt=""/>
          </div>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
    <div class="manage-data">
      <div class="title">经营数据</div>
      <div class="form-box">
        <div class="form-item" @click="showSitePicker = true">
          <div class="val">{{ searchForm.plotName || "全部电站" }}</div>
          <img class="icon" src="@/assets/image/mine/index/manage-image_1.png"/>
        </div>
        <div class="form-item" @click="showTime = true">
          <div class="val">{{ searchForm.time || "全部时间" }}</div>
          <img class="icon" src="@/assets/image/mine/index/manage-image_2.png"/>
        </div>
      </div>
      <div class="chart-box">
        <div class="chart" id="chart"></div>
        <div class="chart-info">
          <div class="chart-title">全部收益</div>
          <div class="chart-money">{{ handleControlNumber(currentPlot.totalAmount || 0, 2) }}</div>
          <div class="chart-tips-box">
            <div class="chart-tips">总收益</div>
            <div class="chart-tips">电费</div>
            <div class="chart-tips">服务费</div>
          </div>
        </div>
      </div>
      <div class="tips-list">
        <div class="tips-item">
          <div class="tips-lable">总收益</div>
          <div class="tips-value">{{ handleControlNumber(currentPlot.totalAmount || 0, 2) }}</div>
        </div>
        <div class="tips-item">
          <div class="tips-lable">电费</div>
          <div class="tips-value">{{ handleControlNumber(currentPlot.chargeFee || 0, 2) }}</div>
        </div>
        <div class="tips-item">
          <div class="tips-lable">服务费</div>
          <div class="tips-value">{{ handleControlNumber(currentPlot.serviceFee || 0, 2) }}</div>
        </div>
      </div>
    </div>
    <div class="charging-list">
      <div class="charging-item" v-for="(item,index) in tableList" :key="`charging-item_${index}`">
        <div class="charging-header">
          <div class="charging-no">{{ item.chargeNo }}</div>
          <div class="charging-state" v-if="item.runningStatus == '0'">
            <img class="charging-icon" src="@/assets/image/mine/index/online.png"/>
            <span class="online">运行</span>
          </div>
          <div class="charging-state" v-else>
            <img class="charging-icon" src="@/assets/image/mine/index/offline.png"/>
            <span class="offline">离线</span>
          </div>
        </div>
        <div class="charging-info">
          <div class="charging-info-item">
            <div class="item-label">总交易额(元)</div>
            <div class="item-value">{{ handleControlNumber(item.totalAmount || 0, 2) }}</div>
          </div>
          <div class="charging-info-item">
            <div class="item-label">电费(元)</div>
            <div class="item-value">{{ handleControlNumber(item.chargeFee || 0, 2) }}</div>
          </div>
          <div class="charging-info-item">
            <div class="item-label">服务费(元)</div>
            <div class="item-value">{{ handleControlNumber(item.serviceFee || 0, 2) }}</div>
          </div>
          <div class="charging-info-item">
            <div class="item-label">充电量(度)</div>
            <div class="item-value">{{ handleControlNumber(item.totalPowerConsumption, 3) }}</div>
          </div>
          <div class="charging-info-item">
            <div class="item-label">充电次数</div>
            <div class="item-value">{{ item.chargeTotalTimes || 0 }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-box">
      <!--      <div class="chart-box" ref="lineChart"></div>-->
    </div>
    <nut-picker
        :is-visible="showSitePicker"
        :list-data="plotList"
        @close="showSitePicker = false"
        @confirm="confirmSite"
    ></nut-picker>
    <van-calendar
        v-model="showTime"
        color="#134FC5"
        type="range"
        :min-date="minDate"
        :max-date="maxDate"
        @close="showTime = false"
        @confirm="confirmTime"
    />
  </div>
</template>

<script>
import {formatDate} from "@/utils/formart";
import {digitUtil} from "@/utils/utils"
import {
  getPlotList,
  getChargeTotal,
  getFeedBackList,
  getEquipList,
} from "@/api/newApi";

export default {
  data() {
    return {
      menuList: [
        // new
        {
          label: "站点管理",
          path: "/admin/site",
          icon: "el-icon-map-location",
          img: require("@/assets/image/newImg/site.png"),
        },
        {
          label: "设备管理",
          path: "/admin/equip",
          icon: "el-icon-s-tools",
          img: require("@/assets/image/newImg/equip.png"),
        },
        {
          label: "订单管理",
          path: "/admin/order",
          icon: "el-icon-tickets",
          img: require("@/assets/image/newImg/order.png"),
        },
        {
          label: "IC卡管理",
          icon: "el-icon-bank-card",
          path: "/admin/card",
          img: require("@/assets/image/newImg/card.png"),
        },
        {
          label: "规则管理",
          path: "/admin/rules",
          icon: "el-icon-edit-outline",
          img: require("@/assets/image/newImg/rules.png"),
        },
        {
          label: "问题反馈",
          path: "/admin/response",
          icon: "el-icon-edit-outline",
          img: require("@/assets/image/newImg/response.png"),
        },
        {
           label: "分成汇总",
           path: "/admin/royalty",
           icon: "el-icon-s-custom",
           img: require("@/assets/image/newImg/royalty.png"),
        }
        // {
        //   label: "用户管理",
        //   path: "/admin/users",
        //   icon: "el-icon-s-custom",
        //   img: require("@/assets/image/newImg/users.png"),
        // },
      ],
      showTime: false,
      showSitePicker: false,
      minDate: new Date(2022, 0, 1),
      maxDate: new Date(),
      plotList: [],
      currentPlot: {},
      searchForm: {
        plotId: null,
        plotName: null,
        /**
         * formatDate(
         *   new Date(
         *    new Date().getFullYear(),
         *    new Date().getMonth(),
         *    new Date().getDate() - 1
         *   ),
         *    "yyyy-MM-dd"
         *   ) +
         *   " - " +
         *   formatDate(new Date(), "yyyy-MM-dd")
         */
        time: null,
        // startTime: formatDate(new Date(), "yyyy-MM-dd"),
        // endTime: formatDate(new Date(), "yyyy-MM-dd"),
        startTime: null,
        endTime: null,
        deviceType: 4,
        pageNo: 1,
        pageSize: 9999,
      },
      myChart2: null,
      orderLine: [],
      powerLine: [],
      timeLine: [],
      equipXdata: [],
      tableList: [],
    };
  },
  watch: {
    "searchForm.plotId": {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.getEquipList();
        }
      },
    },
  },
  computed: {
    percentageChargeFee() {
      return (data) => {
        return (Number(data.chargeFee) / Number(data.totalAmount)) * 100 || 0;
      };
    },
    percentageServiceFee() {
      return (data) => {
        return (Number(data.serviceFee) / Number(data.totalAmount)) * 100 || 0;
      };
    },
  },
  mounted() {
    this.getList();

  },
  methods: {
    handleControlNumber: digitUtil,
    initChart() {
      // 基于准备好的dom，初始化echarts实例
      let chart = document.getElementById('chart');
      if (!chart) return false;
      let myChart = this.$echarts.init(chart);
      myChart.setOption({
        tooltip: {
          show: false
        },
        legend: {
          show: false,
          selectedMode: false
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['50%', '70%'],
            hoverAnimation: false,
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              formatter: function (obj) {
                return `{a|${obj.data.name}}\n\n{b|${obj.data.value}}`
              },
              rich: {
                a: {
                  color: '#888888',//a、b不设置颜色的话，字体颜色就会是饼图颜色的混合色
                  fontSize: '8',
                },
                b: {
                  fontSize: '12',
                  color: '#444444',
                }
              }
            },
            select: {
              disabled: false
            },
            itemStyle: {
              emphasis: {
                label: {
                  show: true,
                  fontSize: 8,
                  fontWeight: 'bold'
                }
              },
            },
            data: [
              {
                value: this.handleControlNumber(this.currentPlot.totalAmount || 0, 2),
                name: '总收益',
                itemStyle: {
                  normal: {color: '#52DA5F'},
                  emphasis: {color: '#52DA5F'}
                }
              },
              {
                value: this.handleControlNumber(this.currentPlot.chargeFee || 0, 2),
                name: '电费',
                itemStyle: {
                  normal: {color: '#5057E4'},
                  emphasis: {color: '#5057E4'}
                }
              },
              {
                value: this.handleControlNumber(this.currentPlot.serviceFee || 0, 2),
                name: '服务费',
                itemStyle: {
                  normal: {color: '#F0B515'},
                  emphasis: {color: '#F0B515'}
                }
              },
            ]
          }
        ]
      })
      let index = 0;
      myChart.dispatchAction({type: "highlight", seriesIndex: 0, dataIndex: 0});
      myChart.on("mouseover", function (e) {
        if (e.dataIndex != index) {
          myChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: index,
          });
        }
      });
      myChart.on("mouseout", function (e) {
        index = e.dataIndex;
        myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex,
        });
      });
    },
    async getList() {
      const res1 = await getPlotList({
        pageNo: 1,
        pageSize: 9999,
        deviceType: 4
      });
      // this.searchForm.plotId = res1.data.records?.[0]?.id;
      // this.searchForm.plotName = res1.data.records?.[0]?.plotName;
      this.searchForm.plotId = null;
      this.searchForm.plotName = null;
      res1.data.records = [{
        plotName: "全部电站",
        id: null
      }].concat(res1.data.records)
      this.plotList = [
        res1.data.records.map((item) => {
          return {
            value: item.plotName,
            label: item.id,
          };
        }),
      ];
      this.getChargeTotal();

    },
    async getChargeTotal() {
      const res2 = await getChargeTotal(this.searchForm);

      this.tableList = [...res2.data.records]
      // 初始化
      this.currentPlot = {
        totalAmount: 0,
        chargeFee: 0,
        serviceFee: 0
      }
      this.tableList.forEach((item,index) => {
        let totalAmount = Number(item.chargeFee) + Number(item.serviceFee);
        this.tableList[index].totalAmount = totalAmount
        this.currentPlot.totalAmount = this.currentPlot.totalAmount + totalAmount
        this.currentPlot.chargeFee = this.currentPlot.chargeFee + Number(item.chargeFee)
        this.currentPlot.serviceFee = this.currentPlot.serviceFee + Number(item.serviceFee)
      })
      this.initChart()
    },
    confirmSite(e) {
      this.searchForm.plotName = e[0].value;
      this.searchForm.plotId = e[0].label;
      this.showSitePicker = false;
      this.getChargeTotal();
    },
    confirmTime(e) {
      this.searchForm.startTime = formatDate(e[0], "yyyy-MM-dd");
      this.searchForm.endTime = formatDate(e[1], "yyyy-MM-dd");
      this.searchForm.time =
          this.searchForm.startTime + " - " + this.searchForm.endTime;
      this.showTime = false;
      this.getChargeTotal();
    },
    async getEquipList() {
      const res = await getEquipList({
        pageNo: 1,
        pageSize: 999,
        deviceType: 4,
        plot: this.searchForm.plotId,
      });
      this.equipXdata = res.data.records.map((item) => item.id);
      this.timeLine = res.data.records.map(
          (item) => item.pileIncomeVO.realHour
      );
      this.powerLine = res.data.records.map(
          (item) => item.pileIncomeVO.consumePower
      );
      this.orderLine = res.data.records.map(
          (item) => item.pileIncomeVO.chargeTimes
      );
    },
    menuItemClick(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

$tips-color-1: #52DA5F;
$tips-color-2: #5057E4;
$tips-color-3: #F0B515;

.main {
  padding: 0.42rem 0.42rem 1.8rem;

  min-height: calc(100vh - 1.8rem);
  background-image: url("~@/assets/image/mine/mine-image_2.png");
  background-size: 100% 45%;
  background-repeat: no-repeat;
  background-color: #F4F4F5;

  .top-box {
    background-color: #fff;
    border-radius: 0.19rem;


    .top-title {
      font-size: 0.35rem;
      padding: 0.3rem 0.3rem;
      padding-bottom: 0;
      color: #444444;
      font-weight: bold;
    }

    .top-list {
      padding: 0.16rem 0.2rem 0 0.2rem;
      padding-bottom: 0.16rem;
      border-radius: 0.19rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .top-item {
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 0.28rem;
        height: 2rem;

        img {
          width: 0.58rem;
          height: auto;
          margin-top: 0.2667rem;
        }

        span {
          font-size: 0.32rem;
          color: #444444;
        }
      }
    }
  }

  .manage-data {
    margin-top: 0.42rem;
    background-color: #fff;
    border-radius: 0.19rem;

    .title {
      font-size: 0.35rem;
      padding: 0.3rem 0.3rem;
      padding-bottom: 0.2rem;
      color: #444444;
      font-weight: bold;
    }

    .form-box {
      display: flex;
      justify-content: space-around;
      padding: 0 0.2rem;
      padding-bottom: 0.2rem;

      .form-item {
        display: flex;
        justify-content: space-between;
        background-color: #F8F8F8;
        border-radius: 1rem;
        padding: 0.15rem 0.33rem;

        &:nth-child(1) {
          width: 40%;
          margin: 0 0.1rem;
        }

        &:nth-child(2) {
          width: 53%;
          margin: 0 0.1rem;
        }

        .val {
          font-size: 0.3rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .val,
        .icon {
          align-self: center;
        }

        .icon {
          width: 0.3rem;
          height: 0.3rem;
        }
      }
    }
  }

  .chart-box {
    display: flex;
    height: auto !important;

    .chart {
      width: 4rem;
      height: 4rem;
    }

    .chart-info {
      padding: 0.8rem 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .chart-title {
        color: #666666;
        font-size: 0.34rem;
      }

      .chart-money {
        color: #444444;
        font-size: 0.54rem;
      }

      .chart-tips-box {
        display: flex;
        justify-content: space-around;
        margin-top: 0.4rem;


        .chart-tips {
          position: relative;
          padding-left: 0.5rem;
          font-size: 0.3rem;

          &:before {
            content: '';
            position: absolute;
            top: 0.12rem;
            left: 0.15rem;
            width: 0.2rem;
            height: 0.2rem;
          }

          &:nth-child(1):before {
            background-color: $tips-color-1;
          }

          &:nth-child(2):before {
            background-color: $tips-color-2;
          }

          &:nth-child(3):before {
            background-color: $tips-color-3;
          }
        }
      }
    }
  }

  .tips-list {
    padding-bottom: 0.2rem;

    .tips-item {
      margin: 0 0.5rem;
      padding: 0.3rem 0;
      padding-bottom: 0.2rem;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ECECEC;

      &:nth-child(1) {
        .tips-lable:before {
          background-color: $tips-color-1;

        }
      }

      &:nth-child(2) {
        .tips-lable:before {
          background-color: $tips-color-2;

        }
      }

      &:nth-child(3) {
        border: 0;

        .tips-lable:before {
          background-color: $tips-color-3;

        }
      }

      .tips-lable {
        color: #666666;
        font-size: 0.2875rem;
        align-self: center;
        padding-left: 0.4rem;
        position: relative;

        &:before {
          content: "";
          position: absolute;
          height: 80%;
          width: 0.07rem;
          left: 0.1rem;
          top: -3px;
          border-radius: 2rem;
          bottom: 0;
          margin: auto 0;
        }
      }

      .tips-value {
        color: #444444;
        align-self: center;
        font-weight: bold;
      }
    }
  }

  .charging-list {
    margin-top: 0.42rem;

    .charging-item {
      margin: 0.1rem 0;
      margin-bottom: 0.2rem;
      background-color: #F1F5FF;
      border-radius: 0.2rem;
      overflow: hidden;


      .charging-header {

        padding: 0.15rem 0.3rem;
        display: flex;
        justify-content: space-between;

        .charging-no {
          align-self: center;
          font-size: 0.35rem;
          color: #444444;
        }

        .offline {
          color: #B4B6BA;
        }

        .online {
          color: #4D77EF;
        }

        .charging-state {
          display: flex;

          .charging-icon {
            width: auto;
            height: 0.3rem;
            margin-right: 0.1rem;
            align-self: center;
          }

          span {
            align-self: center;
            font-size: 0.3rem;
          }
        }
      }

      .charging-info {
        padding: 0.3rem 0.2rem;
        border-radius: 0.4rem 0.4rem 0 0;
        background-color: #FFFFFF;
        display: flex;
        justify-content: space-between;

        .charging-info-item {
          flex: 1;

          .item-label {
            background-color: #F5F5F5;
            font-size: 0.26rem;
            padding: 0.1rem;
            color: #888888;
          }

          .item-value {
            padding: 0.1rem;
            color: #444444;
            font-size: 0.33rem;
          }
        }
      }
    }
  }

  .data-box {
    margin-top: 0.2333rem;

    .data-title {
      margin-bottom: 0.1333rem;
      font-size: 0.4rem;
      color: #000000;
    }

    .data-price-box {
      background-color: #fff;
      padding: 0.45rem 0.36rem 0.44rem 0.42rem;
      border-radius: 0.19rem;

      .data-search {
        margin-bottom: 0.07rem;
        border-bottom: 1px solid #f7f8fd;
      }

      .data-info {
        margin-bottom: 0.23rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .data-info-title {
          display: flex;
          align-items: center;
          font-size: 0.36rem;
          color: #666666;

          span {
            display: inline-block;
            width: 0.08rem;
            height: 0.31rem;
            background: #2e5cef;
            border-radius: 0.04rem;
            margin-right: 0.17rem;
          }
        }

        .data-info-item {
          width: 6rem;
          height: 0.76rem;
          // background: #f7f8fd;
          border-radius: 0.09rem;
          display: inline;
          padding: 0 0.24rem;
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            display: inline-block;
            width: 90%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
            font-size: 0.3733rem;
            color: #666;
          }
        }
      }
    }
  }

  .price-box {
    margin-top: 0.46rem;

    .price-title {
      font-size: 0.36rem;
      color: #666666;
      margin-bottom: 0.1667rem;
    }

    .price-info {
      font-size: 0.54rem;
      color: #1f1d1d;
      font-weight: 600;
    }

    .price-item {
      .price-item-info {
        margin-top: 0.38rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.2rem;
        font-weight: 600;
        font-size: 0.36rem;
        color: #333333;

        .name {
          font-weight: 400;
        }
      }
    }
  }

  .data-chart-title {
    margin-top: 0.55rem;
    display: flex;
    align-items: center;
    font-size: 0.36rem;
    color: #666666;

    span {
      display: inline-block;
      width: 0.08rem;
      height: 0.31rem;
      background: #2e5cef;
      border-radius: 0.04rem;
      margin-right: 0.17rem;
    }
  }

  .chart-box {
    height: 5.867rem;
    background-color: #fff;
    border-radius: 0.1867rem;
  }

  .question-box {
    padding: 0.32rem 0.32rem 0;
    margin-top: 0.2667rem;
    // height: 2.8rem;
    background-color: #fff;
    border-radius: 0.1867rem;

    .question-title {
      font-size: 0.4rem;
      color: #000000;
      margin-bottom: 0.4rem;
    }

    .my-swipe {
      height: 2rem;
      font-size: 0.32rem;

      .swipe-title {
        color: #000000;
        margin-bottom: 0.16rem;
      }

      .swipe-text {
        color: #666666;
      }
    }
  }
}
</style>
